import React from 'react';

function InnerMap() {
  return (
    <div>
      <iframe src="map/index.html" width="100%" height="1000px"></iframe>
    </div>
  );
}

export default InnerMap;